module.exports = {
    contentDescriptorTime: 5000, // Default time for hide content descriptor at player top right use in content_descriptor module
    TRAILER: 'trailer',
    MOVIE: 'movies',
    SERIES: 'series',
    LANG: {
        'off': 'off',
        'en': 'english',
        'es': 'spanish',
        'ar': 'arabic',
        'fr': 'french',
        'eng': 'english',
        'ara': 'arabic',
        'fra': 'french',
        'hi': 'hindi',
        'ml': 'malayalam',
        'ta': 'tamil',
        'te': 'telugu',
        'kn': 'kannada',
        'pa': 'punjabi',
        'bn': 'bengali',
        'ur': 'urdu',
        'mr': 'marathi',
        'bh': 'bhojpuri',
        'gu': 'gujarati',
        'tr': 'turkish',
        'tur': 'turkish',
        'jp': 'japanese',
        'ja': 'japanese',
        'jpn': 'japanese',
        'ko': 'korean',
        'kor': 'korean'
    },
    VERSION: '1.0.0'
};



// WEBPACK FOOTER //
// ./src/starzplayer_constants.js